import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  container: {
    fontFamily: "sans-serif",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    padding: "7px 0",
    borderBottom: "1px solid #23232a",
    fontSize: 13,
  },
  label: {
    color: "#8a8a92",
    fontWeight: 600,
  },
  value: {
    color: "#fff",
    textAlign: "right",
  },
}));

export { useStyles };
